import { Database, Eye, Zap, MapPin, AlertCircle, Crosshair } from 'lucide-react';
import { MainBodyData, KeyTakeawaysData } from './types';

export const weapintContent: MainBodyData = {
  number: '07',
  title: 'Weapons Intelligence (WEAPINT)',
  icon: Crosshair,
  sections: {
    overview: "Weapons Intelligence (WEAPINT) is the process of gathering information about weapons systems, their specifications, proliferation patterns, and supply chains through open sources. This includes analyzing imagery of weapons, tracking arms shipments, monitoring military equipment sales, and assessing conflict-related weapons usage.",
    note: "WEAPINT analysis should focus on public, unclassified information from verified sources. Comply with export controls, sanctions regulations, and international agreements when researching weapons systems.",
    steps: [
      { title: "Identify Weapon Type", description: "Determine specific weapon system, model, and capabilities from imagery or descriptions" },
      { title: "Research Specifications", description: "Find technical specifications, manufacturing details, and capabilities documentation" },
      { title: "Track Supply Chain", description: "Identify manufacturers, exporters, importers, and distribution networks" },
      { title: "Monitor Proliferation", description: "Track weapons movement, transfers, and illicit trade patterns" },
      { title: "Analyze Conflict Usage", description: "Monitor weapons deployment in conflicts and assess their tactical use" },
    ],
    platforms: ["Google Earth/Satellite", "UN Comtrade Database", "SIPRI Arms Transfers", "Flight Tracking (ADS-B)", "Port Authority Records", "Military Databases"],
    dataPoints: [
      "Weapon system identification from imagery analysis",
      "Manufacturing country and export history",
      "Serial numbers and procurement records",
      "Sanctions status and export control regulations",
      "Conflict zone deployment and usage patterns",
      "Supply chain relationships and illicit trade indicators"
    ]
  }
};

export const weapintTakeaways: KeyTakeawaysData = {
  sectionTitle: "WEAPINT",
  takeaways: [
    "Combine multiple intelligence sources to establish weapon identification and provenance",
    "Reference official sanctions lists, export controls, and international agreements",
    "Satellite imagery analysis requires careful interpretation and corroboration",
    "Track manufacturing details and serial numbers for proliferation analysis",
    "Analyze supply chain data to identify sanctions evasion patterns",
    "Document all findings with authoritative sources for policy and investigation support"
  ],
  tools: [
    { name: "Google Earth Pro", category: "SATELLITE IMAGERY", description: "Analyze satellite imagery for weapons systems and military infrastructure", url: "google.com/earth", icon: Eye },
    { name: "UN Comtrade", category: "TRADE DATABASE", description: "UN database of international trade statistics and arms transfers", url: "comtrade.un.org", icon: Database },
    { name: "SIPRI", category: "ARMS TRANSFERS", description: "Stockholm International Peace Research Institute arms transfer database", url: "sipri.org", icon: Database },
    { name: "ADS-B Exchange", category: "AIRCRAFT TRACKING", description: "Real-time tracking of military and cargo aircraft", url: "adsbexchange.com", icon: Zap },
    { name: "MarineTraffic", category: "SHIP TRACKING", description: "Monitor vessel movements for arms smuggling analysis", url: "marinetraffic.com", icon: MapPin },
    { name: "OFAC/Export Controls", category: "SANCTIONS", description: "Search U.S. sanctions and export control lists for weapons systems", url: "ofac-api.com", icon: AlertCircle }
  ]
};